import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ResumePage } from './pages/ResumePage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="w-full min-h-screen bg-[#F7F7F5]" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/resume" element={<ResumePage data-id="element-6" />} data-id="element-5" />
        </Routes>
      </div>
    </BrowserRouter>;
}